import { Guid, IDictionary, IUser } from "@ioip/core/lib";
import { Archivox, ICity, ICountry, IDepartment, ISection } from "@ioip/archivox/lib";
import { JSDataSource } from "./JSDataSource";
import { NativeType } from "../../types/NativeType";
import { IJSPageDataSource } from "../../types/IJSPageDataSource";

export class JSDataSourceCollection {

    #dataSources: IDictionary<JSDataSource> = {};
    #archivox: Archivox;

    constructor(pageDataSources: IJSPageDataSource[]) {

        // Crear fuentes de datos
        for (let i = 0; i < pageDataSources.length; i++) {
            const pageDataSource = pageDataSources[ i ];
            const dataSource = new JSDataSource(pageDataSource.dataSource);

            // Crear la relacion de la fuente de datos con el campo
            for (let j = 0; j < pageDataSource.fields.length; j++) {
                const fieldId = pageDataSource.fields[ j ];
                this.#dataSources[ fieldId ] = dataSource;
            }
        }

        this.#archivox = new Archivox({
            countries: pageDataSources.find(x => x.dataSource?.isNative && x.dataSource?.type == NativeType.Country)?.dataSource?.items as ICountry[] || [],
            departments: pageDataSources.find(x => x.dataSource?.isNative && x.dataSource?.type == NativeType.Department)?.dataSource?.items as IDepartment[] || [],
            cities: pageDataSources.find(x => x.dataSource?.isNative && x.dataSource?.type == NativeType.City)?.dataSource?.items as ICity[] || [],
            sections: (pageDataSources.find(x => x.dataSource?.isNative && x.dataSource?.type == NativeType.Section)?.dataSource?.items || []) as ISection[],
            users: (pageDataSources.find(x => x.dataSource?.isNative && x.dataSource?.type == NativeType.User)?.dataSource?.items || []) as IUser[],
        });

    }

    get archivox(): Archivox {
        return this.#archivox;
    }

    getDataSources(entityId: Guid): JSDataSource {
        return this.#dataSources[ entityId.toString() ];
    }

}